import * as React from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import EditNoteModal from './EditNotes';
import ReopenJobData from './ReopenJobModal';
import AllocateExtendModal from './AllocateExtendModal';
import JobScheduleAddNewData from './JobScheduleAddModal';
import authService from './api-authorization/AuthorizeService';
import * as DateHelpers from './DateHelpers';
import ConfirmPopups from './ConfirmPopup';
import RunsheetEditJobPopup from './RunSheetEditJob';
import AllocateCancelModal from './AllocateCancelItem';
import JobScheduleEditPopup from './JobScheduleEditModal';
import JobScheduleExtendPopup from './JobScheduleExtendModal';
import JobScheduleReOpenPopup from './JobScheduleReOpenItemModal';
import JobQuoteDeliveryAddressData from './JobQuoteDeliveryAddressModal';
import JobScheduleAddPumpCleanPopup from './JobScheduleAddPumpClean';
import JobScheduleVoidModalData from './JobScheduleVoidModal';
import JobScheduleFencingModalData from './JobScheduleFencingModal';

const win: any = window;
const Stimulsoft = win.Stimulsoft;

interface JobScheduleProps {
    systemCompanyId: number;
    jobId: number;
    jobTypeId: number;
    jobStatusId: number;
}

interface JobSchedules {
    loading: boolean;
    errors: any;
    schedule: Schedule[];
    showSave: boolean;
    customerId: number;
    siteAddressDuration: number;
    showEditNotesModal: boolean;
    showReopenModal: boolean;
    showReopenDunnyModal: boolean;
    reopenJob: ReopenJob;
    showExtendModal: boolean;
    showDunnyExtendModal: boolean;
    showCancelledJobs: boolean;
    showAddPumpClean: boolean;
    showAddNewModal: boolean;
    frequencyOptions: GenericList[];
    needsPickup: boolean;
    showProformaInvoice: boolean;
    showEditSimpleJobModal: boolean;
    showDelete: boolean;
    itemIndex: number;
    showCancelModal: boolean;
    cancelDetails: CancelDetails;
    cancelOptions: GenericList[];
    canEditOverhireRate: boolean;
    showOverhireRate: boolean;
    scheduleId: number; //to pass to popup to update overhire rate or delivery address
    jobQuoteItemId: number; //for extending
    accountTypeId: number;  //for extending to open report for prepaid customers only
    showDelAddress: boolean;
    deliveryAddress: DeliveryAddress;   //when editing delivery address
    invoiceDescription: string;
    isJobEvent: boolean;
    showVoidGearList: boolean;
    showFencingDetails: boolean;
}

interface Schedule {
    id: number;
    jobQuoteItemId: number;
    companyId: number;
    itemId: number;
    item: string;
    itemTypeId: number;
    isJobEvent: boolean;
    deliveryAddress: string;
    deliveryAddressGooglePlaceId: string;
    deliveryAddressLatitude: number;
    deliveryAddressLongitude: number;
    invoiceDescription: string;
    quantity: number;
    quantityScheduled: number;
    quantityType: string;
    quantityScheduledType: string;
    quantityTotal: number;
    quantityTotalType: string;
    quantityInvoiced: number;
    quantityInvoicedType: string;
    typeId: number;
    type: string;
    hirePeriodDays: number;
    defaultHirePeriod: number;
    customHirePeriod: boolean;
    frequencyId: number;
    locationId: number;
    status: string;
    statusId: number;
    allocatedTruck: string;
    scheduledDate: string;
    scheduledDateFormatted: string;
    scheduledDateEditable: string;
    onhireDate: string;
    onhireDateFormatted: string;
    onhireDateEditable: string;
    offhireDate: string;
    offhireDateFormatted: string;
    offhireDateEditable: string;
    pickupDateFormatted: string;
    lastHireDateFormatted: string;
    trolley: boolean;
    price: number;
    initial: number;
    travel: number;
    cleaningFee: number;
    trenchFee: number;
    overhireRate: number;
    overhireRateFormatted: string;
    accountTypeId: number;
    unitNumber: string;
    purchaseOrderNumber: string;
    notes: string;
    runsheetNotes: string;
    allowExtend: boolean;
    lastHireDate: string;
    allowReopen: boolean;
    allowDateChange: boolean;       //if user has permission to change dates and there is no vehicle assigned to this job
    allowDelete: boolean;
    allowOnOffHireDateChange: boolean;  //can't update if job has been invoiced
    isKwikstage: boolean;
    vehicleId: number;
    kwikstageItems: ReopenJobKwikstageItem[];
    isEws: boolean;
    isVoid: boolean;
    isFence: boolean;
    isEvent: boolean;
    manualItem: boolean;
    canEdit: boolean;
    canEditOverhire: boolean;
    extrasNote: string;
    reckonUpdatesRequired: boolean;
    customerUpdatesRequired: boolean;
    pending: boolean;
    isDirty: boolean;
}

interface ReopenJob {
    rowIndex: number;
    id: number;
    itemId: number;
    item: string;
    actualQuantity: number;
    quantity: number;
    rescheduleQuantity: number;
    schedulePickup: boolean;
    offhireDate: string;
    scheduleDate: string;
    subId: string;
    isKwikstage: boolean;
    kwikstageItems: ReopenJobKwikstageItem[];
}

interface ReopenJobKwikstageItem {
    id: number;
    jobQuoteItemCalculationId: number;
    starterBayId: number;
    starterBay: string;
    liftId: number;
    lift: string;
    baysTotal: number;
    bays: number;
    newBays: number;
    rescheduleBays: number;
}

interface GenericList {
    id: number;
    name: string;
}

interface CancelDetails {
    rowIndex: number;
    id: number;
    itemId: number;
    item: string;
    cancelReasonId: number;
}

interface DeliveryAddress {
    deliveryAddress: string;
    deliveryAddressGooglePlaceId: string;
    deliveryAddressLatitude: number;
    deliveryAddressLongitude: number;
};

let timeout;

export default class JobSchedule extends React.Component<JobScheduleProps, JobSchedules> {
    constructor(props: JobScheduleProps) {
        super(props);
        this.state = {
            loading: true,
            errors: {},
            schedule: [],
            showSave: false,
            customerId: 0,
            siteAddressDuration: 0,
            showCancelledJobs: false,
            showAddPumpClean: false,
            showEditNotesModal: false,
            showReopenModal: false,
            showReopenDunnyModal: false,
            reopenJob: {
                rowIndex: 0,
                id: 0,
                itemId: 0,
                item: "",
                actualQuantity: 0,
                quantity: 0,
                rescheduleQuantity: 0,
                schedulePickup: false,
                offhireDate: "",
                scheduleDate: "",
                isKwikstage: false,
                subId: "",
                kwikstageItems: []
            },
            showExtendModal: false,
            showDunnyExtendModal: false,
            showAddNewModal: false,
            frequencyOptions: [],
            needsPickup: false,
            showProformaInvoice: false,
            showEditSimpleJobModal: false,
            showDelete: false,
            itemIndex: -1,
            showCancelModal: false,
            cancelDetails: {
                id: 0,
                rowIndex: 0,
                itemId: -1,
                item: "",
                cancelReasonId: -1
            },
            cancelOptions: [],
            canEditOverhireRate: false,
            showOverhireRate: false,
            scheduleId: 0,
            jobQuoteItemId: 0,
            accountTypeId: 0,
            showDelAddress: false,
            deliveryAddress: {
                deliveryAddress: "",
                deliveryAddressGooglePlaceId: "",
                deliveryAddressLatitude: 0,
                deliveryAddressLongitude: 0
            },
            invoiceDescription: "",
            isJobEvent: false,
            showVoidGearList: false,
            showFencingDetails: false
        }
    }

    componentDidMount() {
        this.getJobSchedule(false);
    }

    async getJobSchedule(showCancelledJobs: boolean) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();
        var jobId = this.props.jobId;

        axios.get('api/Job/GetSchedule?SubId=' + user.sub + '&jobId=' + jobId + '&showCancelledJobs=' + showCancelledJobs, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            this.setState({
                schedule: res.data.jobSchedule, showSave: res.data.showSave, customerId: res.data.customerId,
                siteAddressDuration: res.data.siteAddressDuration, frequencyOptions: res.data.frequencyOptions,
                needsPickup: res.data.needsPickup, canEditOverhireRate: res.data.canEditOverhireRate,
                isJobEvent: res.data.isJobEvent, loading: false
            });
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    handleCheckboxChange = (e: any) => {
        let fields = this.state;
        let change: any = {};
        change = fields;
        change[e.target.name] = e.target.checked;
        this.setState(change)

        this.getJobSchedule(e.target.checked);
    }

    onScheduleDateCellChange = (index: number, e: any) => {
        let sched = this.state.schedule;
        let item = sched[index];
        item.scheduledDateEditable = e.target.value;
        item.isDirty = true;

        this.setState({ schedule: sched });
    }

    onPurchaseOrderNumberChange = (index: number, e: any) => {
        let sched = this.state.schedule;
        let item = sched[index];
        item.purchaseOrderNumber = e.target.value;
        item.isDirty = true;

        this.setState({ schedule: sched });
    }

    onUnitNumberChange = (index: number, e: any) => {
        let sched = this.state.schedule;
        let item = sched[index];
        item.unitNumber = e.target.value;
        item.isDirty = true;

        this.setState({ schedule: sched });
    }

    onOnOffDateCellChange = (index: number, e: any) => {
        let sched = this.state.schedule;
        let item = sched[index];
        item.isDirty = true;
        if (item.typeId === 1) {
            item.onhireDateEditable = e.target.value;
        } else if (item.typeId === 2) {
            item.offhireDateEditable = e.target.value;
        }

        this.setState({ schedule: sched });
    }

    //ADD NEW ITEM
    add = () => {
        this.setState({ showAddNewModal: true });
    }

    hideAddNew = () => {
        this.setState({ showAddNewModal: false });
    }

    saveNewItem = () => {
        this.setState({ showAddNewModal: false });

        this.getJobSchedule(this.state.showCancelledJobs);
    }

    //END ADD NEW ITEM

    //EDIT OVERHIRE RATE
    editOverhireRate = (index: number, e: any) => {
        e.preventDefault();
        let sched = this.state.schedule[index];
        this.setState({ itemIndex: index, showOverhireRate: true, scheduleId: sched.id });
    }

    hideOverhireRate = () => {
        this.setState({ itemIndex: -1, showOverhireRate: false, scheduleId: 0 });
    }

    saveOverhireRate = () => {
        this.setState({ itemIndex: -1, showOverhireRate: false, scheduleId: 0 });
        this.getJobSchedule(this.state.showCancelledJobs);
    }

    //END OVERHIRE RATE

    //NOTES
    hideEditNotesModal = () => {
        this.setState({ showEditNotesModal: false, scheduleId: -1, itemIndex: -1 });
    }

    editNotes = (e: any, index: number) => {
        e.preventDefault();
        var scheduleItems = this.state.schedule;
        var scheduleItem = scheduleItems[index];

        this.setState({ showEditNotesModal: true, scheduleId: scheduleItem.id, itemIndex: index });
    }

    saveNotes = (scheduleNotes: string, timestamp: Uint8Array) => {
        var scheduleItems = this.state.schedule;
        var scheduleItem = scheduleItems[this.state.itemIndex];
        scheduleItem.notes = scheduleNotes;

        this.setState({ showEditNotesModal: false, scheduleId: -1, itemIndex: -1 });
    }
    //END NOTES

    //REOPEN 
    reopenItem = (e: any, index: number) => {
        e.preventDefault();
        var scheduleItems = this.state.schedule;
        var scheduleItem = scheduleItems[index];

        if (this.props.systemCompanyId === 3) {
            //reopen a cancelled pump and clean job or an install/pickup that was an accident
            this.setState({ showReopenDunnyModal: true, scheduleId: scheduleItem.id });
        } else {
            var reopenJob: ReopenJob = {
                id: scheduleItem.id,
                rowIndex: index,
                itemId: scheduleItem.itemId,
                item: scheduleItem.item,
                actualQuantity: scheduleItem.quantity,
                quantity: 0,
                rescheduleQuantity: 0,
                schedulePickup: false,
                offhireDate: "",
                scheduleDate: "",
                isKwikstage: scheduleItem.isKwikstage,
                subId: "",
                kwikstageItems: scheduleItem.kwikstageItems
            };

            this.setState({ reopenJob: reopenJob, showReopenModal: true });
        }
    }

    updatedReopenData = (data: any) => {
        this.setState({ reopenJob: data.reopenJob });
    }

    hideReopenModal = () => {
        var reopenJob = this.resetReopenJob();
        this.setState({ showReopenModal: false, showReopenDunnyModal: false, scheduleId: 0, reopenJob: reopenJob });
    }

    resetReopenJob = () => {
        var reopenJob: ReopenJob = {
            id: 0,
            rowIndex: 0,
            itemId: 0,
            item: "",
            actualQuantity: 0,
            quantity: 0,
            rescheduleQuantity: 0,
            schedulePickup: false,
            offhireDate: "",
            scheduleDate: "",
            isKwikstage: false,
            subId: "",
            kwikstageItems: []
        };
        return reopenJob;
    }

    saveReopenJob = () => {
        if (this.props.systemCompanyId === 3) {
            //saved on the modal popup so just close here and refresh screen
            this.setState({ showReopenDunnyModal: false, scheduleId: 0 });
            this.getJobSchedule(this.state.showCancelledJobs);
        } else {
            this.reopenScheduledJob();
        }
    }

    async reopenScheduledJob() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var reopenJob = this.state.reopenJob;
        reopenJob.subId = user.sub;

        //save
        axios.post('api/Job/SaveScheduleReopenJob', reopenJob, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                errors.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                toast.success("Reopen Job Saved");
                var reopenJob = this.resetReopenJob();
                this.setState({ showReopenModal: false, reopenJob: reopenJob });
                //reload the screen
                this.getJobSchedule(this.state.showCancelledJobs);
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }
    //END REOPEN

    //Extend Modal
    extendModal = (e: any, itemIndex: number) => {
        e.preventDefault();
        var scheduleList = this.state.schedule;
        var scheduleItem = scheduleList[itemIndex];

        if (this.props.systemCompanyId === 3) {
            //dunny extend
            this.openDunnyExtend(scheduleItem.id, scheduleItem.jobQuoteItemId, scheduleItem.accountTypeId);
        } else {
            //scaffold extend
            this.openScaffoldExtend(scheduleItem.id, scheduleItem.jobQuoteItemId);
        }
    }

    //scaffold extend
    openScaffoldExtend = (scheduleId: number, jobQuoteItemId: number) => {
        this.setState({ showExtendModal: true, scheduleId: scheduleId, jobQuoteItemId: jobQuoteItemId });
    }

    hideExtendModal = () => {
        this.setState({ showExtendModal: false, scheduleId: 0, jobQuoteItemId: 0 });
    }

    saveExtendData = () => {
        this.setState({ showExtendModal: false, scheduleId: 0, jobQuoteItemId: 0, showCancelledJobs: false });
        toast.success("Item Extended Successfully");
        this.getJobSchedule(false);
    }

    //dunny extend
    openDunnyExtend = (scheduleId: number, jobQuoteItemId: number, acctTypeId: number) => {
        this.setState({ showDunnyExtendModal: true, scheduleId: scheduleId, jobQuoteItemId: jobQuoteItemId, accountTypeId: acctTypeId });
    }

    hideDunnyExtend = () => {
        this.setState({ showDunnyExtendModal: false, scheduleId: 0, jobQuoteItemId: 0, accountTypeId: 0 });
    }

    saveDunnyExtend = () => {
        if (this.state.accountTypeId === 1) {
            //open job request for prepaid customers so payment can be taken
            this.printExtendJob(this.state.jobQuoteItemId);
        }
        this.setState({ showDunnyExtendModal: false, scheduleId: 0, jobQuoteItemId: 0, showCancelledJobs: false, accountTypeId: 0 });
        this.getJobSchedule(false);
    }

    printExtendJob = (jobQuoteItemId: number) => {
        var url = "/job/" + this.props.jobId + "/report/JobExtendRequest/" + jobQuoteItemId;
        window.open(url, '_blank');
    }

    //End Extend Modal

    //ADD MAINT PUMP & CLEAN TO TOILET
    addPumpClean = (e: any, itemIndex: number) => {
        e.preventDefault();

        var items = this.state.schedule;
        var item = items[itemIndex];

        this.setState({
            itemIndex: itemIndex, scheduleId: item.id, showAddPumpClean: true
        });
    }

    hidePumpClean = () => {
        this.setState({ itemIndex: -1, scheduleId: -1, showAddPumpClean: false });
    }

    savePumpClean = () => {
        this.setState({ itemIndex: -1, scheduleId: -1, showAddPumpClean: false });
        this.getJobSchedule(false);
    }
    //END ADD MAINT PUMP & CLEAN TO TOILET

    //DELIVERY ADDRESS
    editDelAddress = (e: any, itemIndex: number) => {
        e.preventDefault();

        var items = this.state.schedule;
        var item = items[itemIndex];

        var delAddr: DeliveryAddress = {
            deliveryAddress: item.deliveryAddress,
            deliveryAddressGooglePlaceId: item.deliveryAddressGooglePlaceId,
            deliveryAddressLatitude: item.deliveryAddressLatitude,
            deliveryAddressLongitude: item.deliveryAddressLongitude
        };
        this.setState({ itemIndex: itemIndex, scheduleId: item.id, showDelAddress: true, deliveryAddress: delAddr, invoiceDescription: item.invoiceDescription });
    }

    hideDelAddress = () => {
        var delAddr = this.resetDeliveryAddress();
        this.setState({ itemIndex: -1, scheduleId: -1, showDelAddress: false, deliveryAddress: delAddr, invoiceDescription: "" });
    }

    updateDelAddress = (updatedDeliveryAddress: DeliveryAddress) => {
        this.setState({ deliveryAddress: updatedDeliveryAddress });
    }

    clearDelAddress = () => {
        var delAddress = this.resetDeliveryAddress();
        this.setState({ deliveryAddress: delAddress });
    }

    resetDeliveryAddress = () => {
        var delAddr: DeliveryAddress = {
            deliveryAddress: "",
            deliveryAddressGooglePlaceId: "",
            deliveryAddressLatitude: 0,
            deliveryAddressLongitude: 0
        };
        return delAddr;
    }

    updateInvDesc = (updatedInvoiceDescription: string) => {
        this.setState({ invoiceDescription: updatedInvoiceDescription });
    }

    updateTrolley = (updatedTrolley: boolean) => {
        //not used
    }

    saveDelAddress = () => {
        this.saveDeliveryAddress();
    }

    saveDeliveryAddress = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var items = this.state.schedule;
        var item = items[this.state.itemIndex];

        if (this.state.deliveryAddress.deliveryAddress != "") {
            item.deliveryAddress = this.state.deliveryAddress.deliveryAddress;
            item.deliveryAddressGooglePlaceId = this.state.deliveryAddress.deliveryAddressGooglePlaceId;
            item.deliveryAddressLatitude = this.state.deliveryAddress.deliveryAddressLatitude;
            item.deliveryAddressLongitude = this.state.deliveryAddress.deliveryAddressLongitude;
        }
        item.invoiceDescription = this.state.invoiceDescription;

        var saveDelAddress = {
            scheduleId: item.id,
            jobQuoteItemId: item.jobQuoteItemId,
            deliveryAddress: this.state.deliveryAddress.deliveryAddress,
            googlePlaceId: this.state.deliveryAddress.deliveryAddressGooglePlaceId,
            deliveryAddressLatitude: this.state.deliveryAddress.deliveryAddressLatitude,
            deliveryAddressLongitude: this.state.deliveryAddress.deliveryAddressLongitude,
            invoiceDescription: this.state.invoiceDescription,
            trolley: item.trolley,
            subId: user.sub
        };

        //save
        axios.post('api/Job/SaveDeliveryAddress', saveDelAddress, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            toast.success("Extras Saved");
            var delAddress = this.resetDeliveryAddress();
            this.setState({ itemIndex: -1, scheduleId: -1, showDelAddress: false, deliveryAddress: delAddress, invoiceDescription: "" });
            this.getJobSchedule(this.state.showCancelledJobs);
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    //END DELIVERY ADDRESS

    printSwms = (e: any, itemIndex: number) => {
        e.preventDefault();

        var scheduleList = this.state.schedule;
        var scheduleItem = scheduleList[itemIndex];

        this.downloadSwms(scheduleItem.scheduledDate, scheduleItem.vehicleId, this.props.jobId);
    }

    async downloadSwms(scheduleDate: string, vehicleId: number, jobId: number) {
        const token = await authService.getAccessToken();

        axios.get('api/Job/GetScheduleSwms?ScheduleDate=' + scheduleDate + "&vehicleId=" + vehicleId + "&jobId=" + jobId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            var swms = res.data.reportData;
            if (swms.length > 0) {
                for (let x = 0; x < swms.length; x++) {
                    let report = new Stimulsoft.Report.StiReport();
                    let reportFile = Stimulsoft.System.IO.File.getFile("reports/" + res.data.reportFileName);
                    report.load(reportFile);

                    report.dictionary.dataStore.clear();

                    let reportData = JSON.stringify(swms[x]);
                    //Dataset created
                    let dataSet = new Stimulsoft.System.Data.DataSet("data");
                    dataSet.readJson(reportData)
                    report.regData(dataSet.dataSetName, "", dataSet);
                    report.reportName = res.data.reportName;
                    report.dictionary.connect(false);
                    report.dictionary.synchronize();

                    //add relationships between data
                    for (var i = 0; i < res.data.reportRelationships.length; i++) {
                        var dataRelation = new Stimulsoft.Report.Dictionary.StiDataRelation(res.data.reportRelationships[i].sourceName, res.data.reportRelationships[i].name, res.data.reportRelationships[i].alias, report.dictionary.dataSources.getByName(res.data.reportRelationships[i].parentTableName), report.dictionary.dataSources.getByName(res.data.reportRelationships[i].childTableName), [res.data.reportRelationships[i].parentFieldName], [res.data.reportRelationships[i].childFieldName]);
                        report.dictionary.relations.add(dataRelation);
                        report.dictionary.synchronize();
                    }
                    report.render();

                    let fileName = res.data.reportName + "-" + (x + 1);

                    timeout = setTimeout(this.downloadReportToPdf, 1000, report, fileName);
                }
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    downloadReportToPdf(report: any, fileName: string) {
        report.exportDocumentAsync(function (pdfData: any) {
            // Save data to file
            Stimulsoft.System.StiObject.saveAs(pdfData, fileName + ".pdf", "application/pdf");
        }, Stimulsoft.Report.StiExportFormat.Pdf);
    }

    validate = () => {
        let errors: any = {};
        let formIsValid = true;
        let items = this.state.schedule.filter(x => x.isDirty);    //only validate items that have changed as they are the only ones to be saved
        var rowNumber = 0;

        var errorString = "Please enter the following values: ";
        var error = false;

        for (var i = 0; i < items.length; i++) {
            rowNumber += 1;
            var newErrorString = "";

            if (!DateHelpers.isValidDate(items[i].scheduledDateEditable)) {
                newErrorString += " Valid Schedule Date, ";
                error = true;
            }

            if (!items[i].manualItem) {
                if (items[i].typeId === 1 && !DateHelpers.isValidDate(items[i].onhireDateEditable)) {
                    newErrorString += " Valid Onhire Date, ";
                    error = true;
                } else if (items[i].typeId === 1 && !DateHelpers.compareDate(items[i].scheduledDateEditable, items[i].onhireDateEditable)) {
                    newErrorString += " Onhire Date >= Schedule Date, ";
                    error = true;
                }
                if (items[i].typeId === 2 && !DateHelpers.isValidDate(items[i].offhireDateEditable)) {
                    newErrorString += " Valid Offhire Date, ";
                    error = true;
                } else if (items[i].typeId === 2 && !DateHelpers.compareDate(items[i].offhireDateEditable, items[i].scheduledDateEditable)) {
                    newErrorString += " Offhire Date <= Schedule Date, ";
                    error = true;
                }
            }

            if (newErrorString != "") {
                errorString += "\n";
                errorString += "Row " + rowNumber + ": " + newErrorString;
                errorString = errorString.substring(0, errorString.length - 2);
            }
        }

        if (error) {
            formIsValid = false;
            errors["scheduleItems"] = errorString;
        }
        this.setState({ errors: errors });
        return formIsValid;
    }

    saveDates = async () => {
        if (this.validate()) {
            let items = this.state.schedule.filter(x => x.isDirty); //only save items that have changed

            if (items.length > 0) {
                const token = await authService.getAccessToken();
                const user = await authService.getUser();

                var saveSchedDates = {
                    items: items,
                    subId: user.sub
                };

                //save
                axios.post('api/Job/SaveScheduleDates', saveSchedDates, {
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                })
                .then(res => {
                    if (res.data.isError) {
                        
                    } else {
                        this.getJobSchedule(this.state.showCancelledJobs);
                        toast.success("Scheduled Job Saved"); 
                    }
                })
                .catch(error => {
                    toast.error(error.message);
                });
            } else {
                toast.info("No items have changed!");
            }
        } else {
            toast.error("Please fix validation errors and try Saving again!");
        }
    }

    //CREATE PROFORMA INVOICE
    invoiceJob = (e: any) => {
        e.preventDefault();
        this.setState({ showProformaInvoice: true });
    }

    hideProformaInvoice = () => {
        this.setState({ showProformaInvoice: false });
    }

    saveProformaInvoice = () => {
        this.saveInvoice();
    }

    saveInvoice = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //there could be multiple items to create an invoice for
        var scheduleIds: number[] = [];
        var jobs = this.state.schedule;

        for (var i = 0; i < jobs.length; i++) {
            if (jobs[i].status != "Cancelled" && jobs[i].typeId === 1) {
                scheduleIds.push(jobs[i].id);
            }
        }
        
        var data = {
            scheduleIds: scheduleIds,
            jobId: this.props.jobId,
            subId: user.sub
        };

        axios.post('api/Invoicing/CreateProformaInvoice', data, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            toast.success("Initial Invoice Created Successfully");
            this.setState({ showProformaInvoice: false });
            this.getJobSchedule(false);
        })
        .catch(error => {
            toast.error(error.message);
        });
    }
    //END CREATE PROFORMA INVOICE

    //EDIT JOB PRICE
    editSimpleJob = (e: any, jobIndex: number) => {
        e.preventDefault();
        var job = this.state.schedule[jobIndex];
        this.setState({ showEditSimpleJobModal: true, scheduleId: job.id, itemIndex: jobIndex });
    }

    hideEditJobModal = () => {
        this.setState({ showEditSimpleJobModal: false, scheduleId: 0, itemIndex: -1 });
    }

    saveEditSimpleJob = (quantityScheduled: number, quantityTotal: number, item: string, itemShortcut: string, rowVersionTimestamp: Uint8Array) => {
        var jobs = this.state.schedule;
        var simpleJob = jobs[this.state.itemIndex];
        simpleJob.quantityScheduled = quantityScheduled;
        simpleJob.quantityTotal = quantityTotal;
        simpleJob.item = item;
        //simpleJob.rowVersionTimestamp = rowVersionTimestamp;

        this.setState({ schedule: jobs, showEditSimpleJobModal: false, scheduleId: 0, itemIndex: -1 });
        this.getJobSchedule(false);
    }
    //END EDIT JOB PRICE

    //CANCEL ITEM - only for Dunnys and only if the job hasn't been allocated to a truck
    cancelItem = (e: any, itemIndex: number) => {
        e.preventDefault();
        this.setState({ showDelete: true, itemIndex: itemIndex });
    }

    hideDelete = () => {
        this.setState({ showDelete: false, itemIndex: -1 });
    }

    saveDelete = () => {
        //need to popup reason for cancelling
        this.setState({ showDelete: false });
        this.getCancelReasons();
    }

    getCancelReasons = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();
        let errors: any = {};
        var schedule = this.state.schedule;
        var scheduleItem = schedule[this.state.itemIndex];

        //get the list of cancel reasons
        axios.get("api/Allocate/CheckCancelOptions?SubId=" + user.sub + "&Id=" + scheduleItem.id + '&JobId=' + this.props.jobId + '&JobQuoteItemId=' + scheduleItem.jobQuoteItemId + '&ScheduleType=' + scheduleItem.typeId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            var cancelReasons = res.data.cancelReasons;
            var cancelOption = res.data.cancelOption;

            if (cancelOption === 1) {
                //show popup to cancel

                let cancelDetails: CancelDetails = {
                    rowIndex: this.state.itemIndex,
                    id: scheduleItem.id,
                    itemId: scheduleItem.itemId,
                    item: scheduleItem.item,
                    cancelReasonId: -1
                };

                this.setState({ showCancelModal: true, cancelDetails: cancelDetails, cancelOptions: cancelReasons });
            } else if (cancelOption === 2) {
                //this job has been split into multiple jobs so Ops MUST Cancel
                toast.error("Cannot cancel this item as the job has been split over multiple trucks. Ops MUST cancel!");
                errors["scheduleItems"] = "Cannot cancel this item as the job has been split over multiple trucks. Ops MUST cancel!";
                this.setState({ errors: errors, itemIndex: -1 });
            } else if (cancelOption === 3) {
                //can't cancel
                toast.error("Cannot cancel this item, see error on screen!");
                var errorString = "Row " + (this.state.itemIndex + 1) + " cannot be cancelled as the remaining qty must be installed to create the Initial Invoice.";
                errors["scheduleItems"] = errorString;
                this.setState({ errors: errors, itemIndex: -1 });
            } else {
                toast.error("Cannot cancel this item as the customer is not setup for Overhire. Extend job instead.");
                errors["scheduleItems"] = "Cannot cancel this item as the customer is not setup for Overhire. Extend job instead.";
                this.setState({ errors: errors, itemIndex: -1 });
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    resetCancelDetails = () => {
        let cancelDetails: CancelDetails = {
            rowIndex: 0,
            id: 0,
            itemId: -1,
            item: "",
            cancelReasonId: -1
        };
        return cancelDetails;
    }

    hideCancelModal = () => {
        var cancelDets = this.resetCancelDetails();

        this.setState({ showCancelModal: false, cancelDetails: cancelDets, cancelOptions: [] });
    }

    updateCancelData = (updatedCancelDetails: CancelDetails) => {
        let cancelDetails = this.state.cancelDetails;
        cancelDetails.cancelReasonId = updatedCancelDetails.cancelReasonId;
        this.setState({ cancelDetails: cancelDetails });
    }

    saveCancel = () => {
        this.saveCancelItem();
    }

    saveCancelItem = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //cancel the item 
        var schedule = this.state.schedule;
        var scheduleItem = schedule[this.state.itemIndex];
        if (scheduleItem) {
            var cancelItem = {
                scheduleId: scheduleItem.id,
                jobId: this.props.jobId,
                itemId: scheduleItem.itemId,
                item: scheduleItem.item,
                cancelReasonId: this.state.cancelDetails.cancelReasonId,
                cancelJobStatus: true,      //set the job item status to cancelled
                manualItem: scheduleItem.manualItem,
                subId: user.sub
            };

            axios.post('api/Allocate/CancelItem', cancelItem, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            })
            .then(res => {
                toast.success("Item Cancelled Successfully");
                var cancelDets = this.resetCancelDetails();
                this.setState({ showCancelModal: false, cancelDetails: cancelDets, cancelOptions: [] });
                this.getJobSchedule(this.state.showCancelledJobs);
            })
            .catch(error => {
                toast.error(error.message);
            });
        }
    }

    //END CANCEL ITEM

    //VOID GEAR LIST
    openVoidGearList = (e: any, itemIndex: number) => {
        e.preventDefault();

        var items = this.state.schedule;
        var item = items[itemIndex];

        this.setState({ itemIndex: itemIndex, jobQuoteItemId: item.jobQuoteItemId, showVoidGearList: true });
    }

    hideVoidGearList = () => {
        this.setState({ itemIndex: -1, jobQuoteItemId: 0, showVoidGearList: false });
    }

    saveVoidGearList = () => {
        this.setState({ itemIndex: -1, jobQuoteItemId: 0, showVoidGearList: false });
    }
    //END VOID GEARLIST

    //FENCING DETAILS
    openFencingDetails = (e: any) => {
        e.preventDefault();
        this.setState({ showFencingDetails: true });
    }

    hideFencingDetails = () => {
        this.setState({ showFencingDetails: false });
    }

    saveFencingDetails = () => {
        this.setState({ showFencingDetails: false });
    }
    //END FENCING DETAILS

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();


        return (<div>
            {contents}
        </div>);
    }

    renderDetails = () => {
        let schedule = this.state.schedule;
        var editNotes = <EditNoteModal systemCompanyId={this.props.systemCompanyId} scheduleId={this.state.scheduleId} editDriverNotes={false} showDriverScheduleNotes={false} showEditNotesModal={this.state.showEditNotesModal} save={this.saveNotes} hideModal={this.hideEditNotesModal} />
        var reopenJob = <ReopenJobData reopenJob={this.state.reopenJob} showModal={this.state.showReopenModal} updateData={this.updatedReopenData} save={this.saveReopenJob} hideModal={this.hideReopenModal} />
        var dunnyReOpenModal = <JobScheduleReOpenPopup showModal={this.state.showReopenDunnyModal} scheduleId={this.state.scheduleId} hideModal={this.hideReopenModal} saveModal={this.saveReopenJob} />
        var extendModal = <AllocateExtendModal scheduleId={this.state.scheduleId} jobQuoteItemId={this.state.jobQuoteItemId} showExtendModal={this.state.showExtendModal} hideModal={this.hideExtendModal} save={this.saveExtendData} />
        var dunnyExtendModal = <JobScheduleExtendPopup showModal={this.state.showDunnyExtendModal} scheduleId={this.state.scheduleId} hideModal={this.hideDunnyExtend} saveModal={this.saveDunnyExtend} />
        var addNewModal = <JobScheduleAddNewData jobId={this.props.jobId} isEvent={this.state.isJobEvent} customerId={this.state.customerId} siteAddressDuration={this.state.siteAddressDuration}  needsPickup={this.state.needsPickup} showModal={this.state.showAddNewModal} hideModal={this.hideAddNew} save={this.saveNewItem} />
        let confirmInvoice = <ConfirmPopups heading="Create Initial Invoice" text="Are you sure you want to create an initial invoice for this job?" showConfirmModal={this.state.showProformaInvoice} hideConfirmModal={this.hideProformaInvoice} saveConfirmModal={this.saveProformaInvoice} />
        let confirmDelete = <ConfirmPopups heading="Cancel Item?" text="Are you sure you want to cancel this item?" showConfirmModal={this.state.showDelete} hideConfirmModal={this.hideDelete} saveConfirmModal={this.saveDelete} />
        var cancelModal = <AllocateCancelModal cancelDetails={this.state.cancelDetails} cancelOptions={this.state.cancelOptions} showModal={this.state.showCancelModal} hideModal={this.hideCancelModal} updateData={this.updateCancelData} save={this.saveCancel} />
        var editOverhireRate = <JobScheduleEditPopup scheduleId={this.state.scheduleId} showModal={this.state.showOverhireRate} hideModal={this.hideOverhireRate} saveModal={this.saveOverhireRate} />
        let delAddressPopup = <JobQuoteDeliveryAddressData deliveryAddress={this.state.deliveryAddress} showDeliveryAddress={true} invoiceDescription={this.state.invoiceDescription} showInvoiceDescription={this.state.isJobEvent} trolleyRequired={false} showTrolley={false} readOnly={false} showModal={this.state.showDelAddress} hideModal={this.hideDelAddress} updateDeliveryAddress={this.updateDelAddress} clearDeliveryAddress={this.clearDelAddress} updateInvoiceDescription={this.updateInvDesc} updateTrolley={this.updateTrolley} saveModal={this.saveDelAddress} />
        let addPumpAndClean = <JobScheduleAddPumpCleanPopup scheduleId={this.state.scheduleId} frequencyOptions={this.state.frequencyOptions} showModal={this.state.showAddPumpClean} hideModal={this.hidePumpClean} saveModal={this.savePumpClean} />
        let editJobPopup = <RunsheetEditJobPopup showModal={this.state.showEditSimpleJobModal} scheduleId={this.state.scheduleId} fromRunsheet={false} systemCompanyId={this.props.systemCompanyId} hideModal={this.hideEditJobModal} saveModal={this.saveEditSimpleJob} />;
        let editVoidGearlist = <JobScheduleVoidModalData showModal={this.state.showVoidGearList} jobQuoteItemId={this.state.jobQuoteItemId} hideModal={this.hideVoidGearList} saveModal={this.saveVoidGearList} />
        let editFencingDetails = <JobScheduleFencingModalData showModal={this.state.showFencingDetails} jobId={this.props.jobId} hideModal={this.hideFencingDetails} saveModal={this.saveFencingDetails} />
        let minDate = DateHelpers.addDaysToCurrentDate(-30);

        return (
            <div>
                {editNotes}
                {reopenJob}
                {extendModal}
                {dunnyExtendModal}
                {dunnyReOpenModal}
                {addNewModal}
                {confirmInvoice}
                {confirmDelete}
                {cancelModal}
                {editOverhireRate}
                {delAddressPopup}
                {addPumpAndClean}
                {editJobPopup}
                {editVoidGearlist}
                {editFencingDetails}
                <div className="makeitflexspacebetween marginBottom10">
                    <label className="input-group" htmlFor="siteAddrExists">
                        <span className="label label--setsizesm">Show Cancelled Jobs?</span>
                        <input className="checkbox" type="checkbox" id="showCancelledJobs" name="showCancelledJobs" checked={this.state.showCancelledJobs} onChange={(e) => this.handleCheckboxChange(e)}></input>
                    </label>
                    <div className={this.props.systemCompanyId === 3 && this.props.jobStatusId != 7 ? "makeitflex" : "hidden"}>
                        <button className={this.props.jobTypeId === 2 || this.props.jobTypeId === 3 ? "defaultbutton marginRight10" : "hidden"} type='button' title="Create an initial invoice for this job" onClick={this.invoiceJob}>Create Initial Invoice</button>
                        <button className="defaultbutton defaultbutton__small" type='button' title="Allows user to schedule in a new item for this job" onClick={this.add}>Add New</button>
                    </div>
                </div>
                <div className="marginLeft10 noteSize">* Items in red are pending payment or go-ahead sign-off.</div>
                <div className="marginLeft10 allocate__customerNoteText">* Items in dark red need Customer unlocked.</div>
                <div className="marginLeft10 allocate__customerReckonNoteText">* Items in blue need Customer linked to Reckon.</div>
                <div className="table__minHeight table__margin overflowAuto">
                    <table className="table table__large tableColours">
                        <thead>
                            <tr>
                                <th className="hidden">Id</th>
                                <th className="table-input--minwidth100">Item</th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th>Type</th>
                                <th>Status</th>
                                <th>Allocated</th>
                                <th className="table-input--minwidth">Qty Total</th>
                                <th className="table-input--minwidth">Qty Sched</th>
                                <th className="table-input--minwidth">Qty</th>
                                <th className="table-input--minwidth">Qty Inv</th>
                                <th>Overhire</th>
                                <th></th>
                                <th>On/Offhire Date</th>
                                <th>Scheduled Date</th>
                                <th>PO No.</th>
                                <th>Unit/Water/Waste No.</th>
                                <th>Edit Job</th>
                                <th className="textaligncenter table-input--minwidth100">Notes</th>
                                <th className="textaligncenter">Extend</th>
                                <th className="textaligncenter">Re-open</th>
                                <th className="textaligncenter">SWMS</th>
                                <th className={this.props.systemCompanyId === 3 ? "" : "hidden"}>Cancel</th>
                            </tr>
                        </thead>
                        <tbody>
                            {schedule.map((item, index) =>
                                <tr key={index}>
                                    <td className="hidden">{item.id}</td>
                                    <td className={"table__text--align" + (item.reckonUpdatesRequired ? " allocate__customerReckonText" : item.customerUpdatesRequired ? " allocate__customerText" : item.pending ? " allocate__redText" : "")}>
                                        {item.item}
                                    </td>
                                    <td className="table__text--align">
                                        <a className={item.itemTypeId === 25 && item.frequencyId === 0 && (item.statusId === 4 || item.statusId === 6) ? "tooltipitem tooltipitem__right" : "hidden"} href="#" onClick={(e) => this.addPumpClean(e, index)}>
                                            <span className="fa-solid fa-circle-plus edit--icon alignIconCenter"></span>
                                            <span className="tooltipitemtext tooltipitemtext__right">Add maintenance pump & clean to toilet</span>
                                        </a>
                                    </td>
                                    <td className="table__text--align">
                                        <a className={item.statusId === 3 && !item.manualItem && (item.isEvent || item.isJobEvent) ? "tooltipitem tooltipitem__right alignIconCenter" + (item.deliveryAddress == "" ? "" : " makeitgreen") : "hidden"} href="#" onClick={(e) => this.editDelAddress(e, index)}>
                                            <span className="fas fa-edit copy--icon"></span>
                                            <span className="tooltipitemtext tooltipitemtext__right">Add/Edit Delivery Address if different to Site Address</span>
                                        </a>
                                    </td>
                                    <td className="table__text--align">
                                        <a className={item.isVoid && item.statusId > 2 && item.statusId < 7 ? "tooltipitem tooltipitem__right" : "hidden"} href="#" onClick={(e) => this.openVoidGearList(e, index)}>
                                            <span className="fas fa-edit edit--icon alignIconCenter"></span>
                                            <span className="tooltipitemtext tooltipitemtext__right">Update the void gear list</span>
                                        </a>
                                        <a className={item.isFence && item.statusId > 2 && item.statusId < 8 ? "tooltipitem tooltipitem__right" : "hidden"} href="#" onClick={(e) => this.openFencingDetails(e)}>
                                            <span className="fas fa-edit edit--icon alignIconCenter"></span>
                                            <span className="tooltipitemtext tooltipitemtext__right">View Fencing Details</span>
                                        </a>
                                    </td>
                                    <td className={"table__text--align" + (item.reckonUpdatesRequired ? " allocate__customerReckonText" : item.customerUpdatesRequired ? " allocate__customerText" : item.pending ? " allocate__redText" : "")}>{item.type}</td>
                                    <td className={"table__text--align" + (item.reckonUpdatesRequired ? " allocate__customerReckonText" : item.customerUpdatesRequired ? " allocate__customerText" : item.pending ? " allocate__redText" : "")}>{item.status}</td>
                                    <td className={"table__text--align" + (item.reckonUpdatesRequired ? " allocate__customerReckonText" : item.customerUpdatesRequired ? " allocate__customerText" : item.pending ? " allocate__redText" : "")}>{item.allocatedTruck}</td>
                                    <td className={"table__text--align" + (item.reckonUpdatesRequired ? " allocate__customerReckonText" : item.customerUpdatesRequired ? " allocate__customerText" : item.pending ? " allocate__redText" : "")}>{item.quantityTotalType}</td>
                                    <td className={"table__text--align" + (item.reckonUpdatesRequired ? " allocate__customerReckonText" : item.customerUpdatesRequired ? " allocate__customerText" : item.pending ? " allocate__redText" : "")}>{item.quantityScheduledType}</td>
                                    <td className={"table__text--align" + (item.reckonUpdatesRequired ? " allocate__customerReckonText" : item.customerUpdatesRequired ? " allocate__customerText" : item.pending ? " allocate__redText" : "")}>{item.quantityType}</td>
                                    <td className={"table__text--align" + (item.reckonUpdatesRequired ? " allocate__customerReckonText" : item.customerUpdatesRequired ? " allocate__customerText" : item.pending ? " allocate__redText" : "")}>{item.quantityInvoicedType}</td>
                                    <td className={"table__text--align" + (item.reckonUpdatesRequired ? " allocate__customerReckonText" : item.customerUpdatesRequired ? " allocate__customerText" : item.pending ? " allocate__redText" : "")}>{item.manualItem ? "" : item.overhireRateFormatted}</td>
                                    <td className={"table__text--align" + (item.reckonUpdatesRequired ? " allocate__customerReckonText" : item.customerUpdatesRequired ? " allocate__customerText" : item.pending ? " allocate__redText" : "")}>
                                        <a className={this.state.canEditOverhireRate && item.canEditOverhire && !item.manualItem && item.typeId === 1 ? "tooltipitem tooltipitem__right alignIconCenter" : "hidden"} href="#" onClick={(e) => this.editOverhireRate(index, e)}>
                                            <span className="fas fa-edit copy--icon"></span>
                                            <span className="tooltipitemtext tooltipitemtext__right">Edit Overhire Rate (USE CAUTION)</span>
                                        </a>
                                    </td>
                                    <td className={"table__text--align" + (item.reckonUpdatesRequired ? " allocate__customerReckonText" : item.customerUpdatesRequired ? " allocate__customerText" : item.pending ? " allocate__redText" : "")}>
                                        <input type='date' min={minDate} className={item.allowOnOffHireDateChange && item.typeId != 3 && !item.manualItem ? "form-control allocate__dateSize" : "hidden"} value={item.typeId === 1 ? item.onhireDateEditable : item.offhireDateEditable} onChange={(e) => this.onOnOffDateCellChange(index, e)} />
                                        {item.allowOnOffHireDateChange ? "" : item.typeId === 1 ? item.onhireDateFormatted : item.offhireDateFormatted}
                                    </td>
                                    <td className={"table__text--align" + (item.reckonUpdatesRequired ? " allocate__customerReckonText" : item.customerUpdatesRequired ? " allocate__customerText" : item.pending ? " allocate__redText" : "")}>
                                        <input type='date' min={minDate} className={item.allowDateChange ? "form-control allocate__dateSize" : "hidden"} value={item.scheduledDateEditable} onChange={(e) => this.onScheduleDateCellChange(index, e)} />
                                        {item.allowDateChange ? "" : item.scheduledDateFormatted}
                                    </td>
                                    <td className={"table__text--align" + (item.reckonUpdatesRequired ? " allocate__customerReckonText" : item.customerUpdatesRequired ? " allocate__customerText" : item.pending ? " allocate__redText" : "")}>
                                        <input type="text" maxLength={25} className={item.statusId != 8 && !item.manualItem && (item.typeId === 1 || item.typeId === 2) ? "form-control allocate__size130" : "hidden"} value={item.purchaseOrderNumber} onChange={(e) => this.onPurchaseOrderNumberChange(index, e)} />
                                        {item.statusId != 8 ? "" : item.purchaseOrderNumber}
                                    </td>
                                    <td className={"table__text--align" + (item.reckonUpdatesRequired ? " allocate__customerReckonText" : item.customerUpdatesRequired ? " allocate__customerText" : item.pending ? " allocate__redText" : "")}>
                                        <input type="text" maxLength={25} className={item.statusId != 8 && !item.manualItem && (item.typeId === 1 || item.typeId === 2) ? "form-control allocate__dateSize" : "hidden"} value={item.unitNumber} onChange={(e) => this.onUnitNumberChange(index, e)} />
                                        {item.statusId != 8 ? "" : item.unitNumber}
                                    </td>
                                    <td className="table__text--align">
                                        <a className={item.typeId === 1 && !item.manualItem && item.canEdit && item.companyId === 3 ? "" : "hidden"} href="#" onClick={(e) => this.editSimpleJob(e, index)}>
                                            <span className="fas fa-folder-open copy--icon alignIconCenter tooltipitem tooltipitem__left"><span className="tooltipitemtext tooltipitemtext__left">Edit job if changes to plan (USE CAUTION)</span></span>
                                        </a>
                                    </td>
                                    <td className={"table__text--align" + (item.reckonUpdatesRequired ? " allocate__customerReckonText" : item.customerUpdatesRequired ? " allocate__customerText" : item.pending ? " allocate__redText" : "")}>
                                        <a className={item.notes == "" ? "hidden" : ""} data-toggle="modal" data-target="#notesModal" href="#" onClick={(e) => this.editNotes(e, index)}>
                                            <div className="tooltipitem tooltipitem__left">{item.notes ? item.notes.substring(0, 20) + "... " : ""}
                                                <span className="tooltipitemtext tooltipitemtext__large tooltipitemtext__left">{item.notes}</span>
                                            </div>
                                        </a>
                                        <a className={item.notes != "" ? "hidden" : ""} data-toggle="modal" data-target="#notesModal" href="#" onClick={(e) => this.editNotes(e, index)}>
                                            <span className="fas fa-pencil-alt edit--icon alignIconCenter"></span>
                                        </a>
                                    </td>
                                    <td className={"table__text--align" + (item.reckonUpdatesRequired ? " allocate__customerReckonText" : item.customerUpdatesRequired ? " allocate__customerText" : item.pending ? " allocate__redText" : "")}>
                                        <a className={item.allowExtend && item.status != "Cancelled" && item.status != "Picked Up" ? "" : "hidden"} data-toggle="modal" data-target="#extendModal" href="#" onClick={(e) => this.extendModal(e, index)}>
                                            <span className="fas fa-arrow-right edit--icon alignIconCenter"></span>
                                        </a>
                                    </td>
                                    <td className={"table__text--align" + (item.reckonUpdatesRequired ? " allocate__customerReckonText" : item.customerUpdatesRequired ? " allocate__customerText" : item.pending ? " allocate__redText" : "")}>
                                        <a className={item.allowReopen ? "" : "hidden"} href="#" onClick={(e) => this.reopenItem(e, index)}>
                                            <span className="fas fa-folder-open edit--icon alignIconCenter"></span>
                                        </a>
                                    </td>
                                    <td className={"table__text--align" + (item.reckonUpdatesRequired ? " allocate__customerReckonText" : item.customerUpdatesRequired ? " allocate__customerText" : item.pending ? " allocate__redText" : "")}>
                                        <div className={this.props.systemCompanyId === 2 ? "" : "hidden"}>
                                            <a className={item.vehicleId === 0 ? "hidden" : ""} href="#" onClick={(e) => this.printSwms(e, index)}>
                                                <span className="fas fa-file-shield edit--icon alignIconCenter"></span>
                                            </a>
                                        </div>
                                    </td>
                                    <td className={this.props.systemCompanyId === 3 ? "" : "hidden"}>
                                        <div className={item.allowDelete ? "delete--tablecell" : "hidden"}>
                                            <a className="makeitred" href="#" onClick={(e) => this.cancelItem(e, index)}>
                                                <span className="fas fa-times-circle delete--icon alignIconCenter"></span>
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    {this.state.errors["scheduleItems"] ?
                        (this.state.errors["scheduleItems"]).split("\n").map((item: any, key: any) => {
                            return <span className="label errors" key={key}>{item}<br /></span>
                        })
                        : ""}
                </div>
                <div className="colAlignRight marginBottom10">
                    <button className={this.state.showSave ? "defaultbutton defaultbutton__large" : "hidden"} type="button" onClick={this.saveDates}>Save</button>
                </div>
            </div>
        )
    }

}
